import {useMutation} from '@tanstack/react-query'
import {PostSiemHttpIntegrationRequest} from 'interfaces'

import {SIEMService} from 'services/api'

interface UseCreateSiemHttpIntegrationMutation {
  refetchSiemHttpIntegration: () => void
}

export const useCreateSiemHttpIntegrationMutation = ({
  refetchSiemHttpIntegration,
}: UseCreateSiemHttpIntegrationMutation) => {
  return useMutation({
    mutationFn: (payload: PostSiemHttpIntegrationRequest) =>
      SIEMService.postSiemHttpIntegration(payload),
    onSuccess: () => {
      refetchSiemHttpIntegration()
    },
  })
}

interface UseDeleteSiemHttpIntegrationMutation {
  refetchSiemHttpIntegration: () => void
}
export const useDeleteSiemHttpIntegrationMutation = ({
  refetchSiemHttpIntegration,
}: UseDeleteSiemHttpIntegrationMutation) => {
  return useMutation({
    mutationFn: () => SIEMService.deleteSiemHttpIntegration(),
    onSuccess: () => {
      refetchSiemHttpIntegration()
    },
  })
}
